import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar, PortalWrapper } from 'mw-style-react';
import cn from 'classnames';
import AppUtils from '@control-front-end/utils/utils';
import { intlShape } from 'react-intl';
import FormTab from './FormTab';
import FormSectionsPanel from './FormSectionsPanel';
import mes from './intl';
import './Form.scss';

/**
 * Рендеринг Формы
 */
class Form extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: structuredClone(props.form),
      formErrors: [],
      updateTime: props.updateTime,
      activeSection: -1,
      formHeight: 'auto',
    };
    this.formTabRef = React.createRef();
    this.formContainerRef = React.createRef();
    this.handleSelectSection = this.handleSelectSection.bind(this);
  }

  componentDidMount() {
    const { form, type } = this.props;
    const wrapSections = type === 'modal' && form.sections.length > 0;
    if (wrapSections) {
      setTimeout(() => this.adjustFormSize(), 10);
    }
  }

  adjustFormSize() {
    const extraSectionRootEl = document.getElementById('extraSection');
    this.setState({ extraSectionRootEl });
    const formContainer = this.formContainerRef.current;
    if (!formContainer) return;
    const rootContainer = formContainer.parentElement;
    const { height } = rootContainer.getBoundingClientRect();
    this.setState({ formHeight: `${height - 40}px` });
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  getFormData() {
    if (!this.formTabRef.current) return;
    return this.formTabRef.current.handleSubmit();
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  getFormErrors() {
    const { formErrors } = this.state;
    return formErrors;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.updateTime !== state.updateTime) {
      return {
        form: props.form,
        updateTime: props.updateTime,
      };
    }
    return null;
  }

  // Ф-ция локализации
  i(mesId, values) {
    return AppUtils.getMes(this.context)(mesId, values);
  }

  handleSelectSection({ value }) {
    this.setState({ activeSection: value });
  }

  renderContent() {
    const { form, formId, onChange, onSubmit, type, extraSection } = this.props;
    const { activeSection, extraSectionRootEl } = this.state;
    const wrapSections = type === 'modal' && form.sections.length > 0;
    return (
      <>
        {wrapSections ? (
          <FormSectionsPanel
            formRef={this.formTabRef}
            sections={form.sections}
            activeSection={activeSection}
            onSelect={this.handleSelectSection}
          />
        ) : null}
        {extraSection && extraSectionRootEl ? (
          <PortalWrapper root={extraSectionRootEl} position="inherit">
            {extraSection}
          </PortalWrapper>
        ) : null}
        <FormTab
          ref={this.formTabRef}
          form={this.state.form}
          formId={formId}
          requiredErrorMsg={this.i(mes.requiredField)}
          onChange={(formData) => {
            const copyFormData = { ...formData };
            this.setState({ form: copyFormData });
            onChange(copyFormData);
          }}
          onError={(formData, formErrors) => {
            const copyFormData = { ...formData };
            this.setState({ form: copyFormData, formErrors });
          }}
          onSubmit={onSubmit}
          activeSection={activeSection}
          wrapSections={wrapSections}
        />
      </>
    );
  }

  render() {
    const { type } = this.props;
    const { form, formHeight } = this.state;
    const isLoaded = form && Object.keys(form).length > 0;
    if (!isLoaded) {
      return (
        <div styleName="formLoader">
          <ProgressBar />
        </div>
      );
    }
    return (
      <div
        ref={this.formContainerRef}
        id={form.id}
        styleName={cn('form', type)}
        style={{ height: formHeight }}
      >
        <div styleName="form__wrap">
          {type === 'single' ? (
            <div styleName="form__header">
              <div styleName="form__header__title">{form.title}</div>
              {form.description && form.description.length ? (
                <div styleName="form__header__description">
                  {form.description}
                </div>
              ) : null}
            </div>
          ) : null}
          <div styleName="form__content">{this.renderContent()}</div>
        </div>
      </div>
    );
  }
}

Form.defaultProps = {
  type: 'single',
  onChange: () => {},
  onSubmit: () => {},
  formAttendees: [],
};

Form.propTypes = {
  type: PropTypes.oneOf(['page', 'single', 'panel', 'modal']),
  form: PropTypes.object.isRequired,
  formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  updateTime: PropTypes.number,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  extraSection: PropTypes.node,
};

Form.contextTypes = {
  intl: intlShape,
};

export default Form;
